import app, { Component, on } from 'apprun';
import {registration} from './api';
import {validator} from './api';

import {isValid} from './utils';

import _,{lang, setLanguage}  from './l10n';

declare var id;
declare var email;
declare var timestamp;
declare var hash;
declare var userName;

const ThankYouMessage = ()=>{
  let ThanksMessage;
  if(lang == 'fr-ca'){
    ThanksMessage = '_html:<form><div><p>FRENCH: Your password has been succesfully changed.</p><p>Click <a href=\'/Account/Login\'>here</a> to login.</p></div></form>'
  }else{
    ThanksMessage = '_html:<form><div><p>Your password has been succesfully changed.</p><p>Click <a href=\'/Account/Login\'>here</a> to login.</p></div></form>'
  }
  return ThanksMessage;

}

export default class SetPasswordComponent extends Component {
  
  state = {
    email:'',
    password:'',
    confirmPassword: '',
    timestamp:'',
    hash:'',
    id:0,
    showMessage:false,    
    userName:''
  };

  view = state => {
    return (
     
      <div>    
 {state.showMessage ?
        <ThankYouMessage/>
      :
        
<form id="RgistrationForm">


<h2>{_('Set Password')}</h2>

<div id="RgistrationFormErrorSummary" className="text-danger ng-isolate-scope alert-danger"></div>

<table className="table table-condensed table-bordered table-striped table-hover" >
  <tbody>
  <tr>
    <th className="ng-scope">{_('Email Address/User Name')}</th>
    <td className="ng-binding">{state.userName}</td>
  </tr>


  <tr>
    <td className="ng-scope">{_('Password')}</td>
    <td className="ng-binding"><input type="password" name="password" id="password" required="required" data-validate="PWD" displayFieldName = {_('Password')} className='pull-left' oninput={e=> this.run('binding', e) }></input></td>
  </tr>
  
  <tr>
    <td className="ng-scope">{_('Confirm Password')}</td>
    <td className="ng-binding"><input type="password" name="confirmPassword" id="confirmPassword" required="required"  displayFieldName = {_('Confirm Password')} className='pull-left' oninput={e=> this.run('binding', e) }></input></td>
  </tr>
  </tbody>
</table>

<button type="button" onclick={e => this.run('setPassword', e)} className="btn btn-default btn-icon">{_('Submit')}</button>
</form>
     } 
      </div>
    );
  };

  update = {
    '#set-password': state => { 
      var lang = location.search.split('lang=')[1];

      if(lang){
        if(lang == 'fr')
          setLanguage('fr-ca');
        else
          setLanguage('en-ca');
      }

      state={...state, id, email, timestamp, hash, userName};
      return state;
    },

    setPassword: async (state, e) => {
        const formName='RgistrationForm';
      
        if (!isValid(formName)) return;

        if (state.password != state.confirmPassword) {

            let errDiv = document.getElementById('RgistrationFormErrorSummary') as HTMLDivElement;

            if(lang == 'fr-ca')
              errDiv.innerHTML = "<p>* Le mot de passe et le mot de passe de confirmation sont différents.</p>";
            else
              errDiv.innerHTML = "<p>* password and confirm password don't match.</p>";

            let passwordDiv = document.getElementById("password" ) as HTMLInputElement;
            passwordDiv.value = "";

            let confirmPasswordDiv = document.getElementById("confirmPassword" ) as HTMLInputElement;
            confirmPasswordDiv.value = "";

            state.password = "";
            state.confirmPassword = "";

            return ;
          }         
        
         
        let setPassword = await registration.setPassword(state);    
        console.log(setPassword); 
        state.showMessage = true;

        return state;
    },
      
    binding: (state, e) => {
      state[e.target.id] = e.target.value;
      return state;
    }

  };

  private testMethod(state, user) {
    return null;
  }
}

new SetPasswordComponent().mount('assr-app');
